const covid19BlockedDrugList = ["remdesivir", "veklury", "lagevrio", "molnupiravir", "paxlovid", "sotrovimab", "xevudy", "ronapreve", "casirivimab", "tocilizumab", "actemra", "regdanvimab", "regkirona", "evusheld"];

export default covid19BlockedDrugList;
